import { render, staticRenderFns } from "./layoutCenter.vue?vue&type=template&id=48b0c45a&scoped=true&"
import script from "./layoutCenter.vue?vue&type=script&lang=js&"
export * from "./layoutCenter.vue?vue&type=script&lang=js&"
import style0 from "./layoutCenter.vue?vue&type=style&index=0&id=48b0c45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0c45a",
  null
  
)

export default component.exports